import type React from "react";
import { Group, Paper, Stack, Text } from "@mantine/core";
import { IconBulb } from "@tabler/icons-react";

interface AnswerPanelProps {
  answer: string;
}

/** The answer on top of the results, in the theme's success (green) colour. */
const AnswerPanel: React.FC<AnswerPanelProps> = ({ answer }) => (
  <Paper radius="md" p="lg" bg="var(--mantine-color-green-0)">
    <Stack gap="xs">
      <Group gap={6}>
        <IconBulb size={16} color="var(--mantine-color-green-7)" />
        <Text size="xs" tt="uppercase" fw={600} c="green.8">
          Answer from the top result
        </Text>
      </Group>
      <Text size="lg" fw={500}>
        {answer}
      </Text>
    </Stack>
  </Paper>
);

export default AnswerPanel;
